import { Button } from '@/components/common';
import { useDashboard } from './useDashboard';
import { DashboardKPIs } from './DashboardKPIs';
import { RevenueChart } from './RevenueChart';

export function DashboardPage() {
  const {
    kpis,
    revenue,
    isLoadingKpis,
    isLoadingRevenue,
    kpisError,
    revenueError,
    refresh,
    isRefreshing,
  } = useDashboard();

  return (
    <div className="space-y-8">
      {/* Header — matches legacy .dash-header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-[26px] font-extrabold text-[#1a1a1a]">Dashboard</h1>
          <p className="text-[13px] uppercase tracking-[2px] text-[#999]">Overview</p>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={refresh}
          disabled={isRefreshing}
          aria-label="Refresh dashboard"
        >
          {isRefreshing ? 'Refreshing...' : 'Refresh'}
        </Button>
      </div>

      {/* KPI Cards */}
      <DashboardKPIs data={kpis} isLoading={isLoadingKpis} error={kpisError} />

      {/* Revenue Chart */}
      <RevenueChart data={revenue} isLoading={isLoadingRevenue} error={revenueError} />
    </div>
  );
}
